import {
  CheckCircleOutlined,
  PlusOutlined,
  FilterOutlined,
} from "@ant-design/icons";
import { Space } from "antd";
import { useTranslation } from "react-i18next";

import { Tag } from "@/ui/tag";

const SectionTags = ({ section }) => {
  const { t } = useTranslation();

  const isTemplateSectionTag = "type" in section;

  /**
   * Check if section is dynamic.
   *
   * @return {bool}
   */
  function isDynamic() {
    return !section.repetition_index && section.flags?.dynamic;
  }

  /**
   * Check if section has asset types filter.
   *
   * @return {bool}
   */
  function hasAssetTypesFilter() {
    return section.types?.length;
  }

  /**
   * Check is section is fillable.
   *
   * @return {bool}
   */
  function isFillable() {
    return !!section.progress?.toFill;
  }

  /**
   * Check if section has a category.
   *
   * @return {bool}
   */
  function hasCategory() {
    return !!section.category;
  }

  /**
   * Get progress color
   *
   * @return {string}
   */
  function colorProgress(progress) {
    return progress.validated || progress.filled >= progress.toFill
      ? "success"
      : progress.filled
        ? "warning"
        : "error";
  }

  const Progress = () =>
    isFillable(section) && !isDynamic() ? (
      <Tag
        color={colorProgress(section.progress)}
        icon={section.progress.validated && <CheckCircleOutlined />}
      >
        {section.progress.filled}/{section.progress.toFill}
      </Tag>
    ) : null;

  const Flags = () => (
    <Space size="small">
      {hasAssetTypesFilter() ? (
        <Tag icon={<FilterOutlined />}>{t("global:assetTypePlural")}</Tag>
      ) : null}
      {isDynamic() ? (
        <Tag icon={<PlusOutlined />}>
          {isTemplateSectionTag
            ? t("interventionTemplate:dynamic.label")
            : t("global:add")}
        </Tag>
      ) : null}
      {hasCategory() ? (
        <Tag>{t("interventionTemplate:category:" + section.category)}</Tag>
      ) : null}
    </Space>
  );

  return (
    <Space size="small">
      <Flags />
      <Progress />
    </Space>
  );
};

export default SectionTags;
